
import React, { useEffect, useState } from "react";
import { useWebData } from "../../Context/webDataContext";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

function ServiceCard({ title, image, width = "100%", height = "h-[200px]" }) {
  return (
    <div
      className={`rounded-lg overflow-hidden relative border border-gray-200`}
      style={{ width }}
    >
      <div className={`w-full overflow-hidden relative ${height} rounded-xl`}>
        <img src={image} alt={title} className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent" />
      </div>

      <div className="absolute bottom-4 left-4 z-10">
        <h3 className="text-white text-sm md:text-lg font-semibold drop-shadow-md bg-black/60 px-3 py-1 rounded">
          {title}
        </h3>
      </div>
    </div>
  );
}

function MobileCarousel({ services }) {
  const [currentIndex, setCurrentIndex] = useState(0);

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev === 0 ? services.length - 1 : prev - 1));
  };

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev === services.length - 1 ? 0 : prev + 1));
  };

  return (
    <div className="relative w-full overflow-hidden">
      <div
        className="flex transition-transform duration-500 ease-in-out"
        style={{ transform: `translateX(-${currentIndex * 100}%)` }}
      >
        {services.map((service, index) => (
          <div key={index} className="min-w-full relative">
            <img
              src={service.imgUrl}
              alt={service.title}
              className="w-full h-[200px] object-cover rounded-xl"
            />
            <div className="absolute bottom-4 left-16 text-white font-semibold bg-black/60 px-3 py-1 rounded">
              {service.title}
            </div>
          </div>
        ))}
      </div>

      {/* Prev Button */}
      <button
        onClick={prevSlide}
        className="absolute top-1/2 -left-2 transform -translate-y-1/2 z-10 p-2 text-white bg-[#FFF]/80 hover:bg-black/70 rounded-r-md"
      >
        <FaChevronLeft size={20} color="#08875D"/>
      </button>

      {/* Next Button */}
      <button
        onClick={nextSlide}
        className="absolute top-1/2 -right-2 transform -translate-y-1/2 z-10 p-2 text-white bg-[#FFF]/80 hover:bg-black/70 rounded-l-md"
      >
        <FaChevronRight size={20} color="#08875D" />
      </button>
    </div>
  );
}

export default function ServicesAlbum() {
  const { getServicesAlbumData } = useWebData();
  const albumData = getServicesAlbumData();

  const title = albumData.title || "Services We Offer";
  const subtitle =
    albumData.subtitle ||
    "From cleaning to babysitting, Maideaze connects you with skilled professionals to handle all your household tasks.";
  const services = albumData.services || [];

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 768);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const visibleServices = services.slice(0, 6); // restrict to first 6 services

  return (
    <div className="max-w-6xl mx-auto py-10 " id="services">
      <h2 className="text-center text-3xl md:text-5xl font-bold primary-text">
        {title}
      </h2>
      <p className="text-center text-gray-700 md:mt-4 mt-2 max-w-2xl mx-auto px-4 md:text-lg text-sm">
        {subtitle}
      </p>

      <div className="max-w-7xl mx-auto mt-10">
        {isMobile ? (
          <MobileCarousel services={visibleServices} />
        ) : (
          <div className="flex flex-col gap-8">
            {/* Top Layout */}
            <div className="flex gap-6">
              <div className="flex flex-col gap-4 w-2/3">
                <div className="flex gap-4">
                  <div className="w-2/5">
                    <ServiceCard
                      title={services[0]?.title}
                      image={services[0]?.imgUrl}
                      height="h-[150px] md:h-[240px]"
                    />
                  </div>
                  <div className="w-3/5">
                    <ServiceCard
                      title={services[1]?.title}
                      image={services[1]?.imgUrl}
                      height="h-[150px] md:h-[240px]"
                    />
                  </div>
                </div>
                <ServiceCard
                  title={services[2]?.title}
                  image={services[2]?.imgUrl}
                  height="h-[150px] md:h-[240px]"
                />
              </div>

              <div className="w-1/3">
                <ServiceCard
                  title={services[3]?.title}
                  image={services[3]?.imgUrl}
                  height="h-[200px] md:h-[500px]"
                />
              </div>
            </div>

            {/* Bottom Layout */}
            <div className="flex gap-4">
              <div className="w-1/3">
                <ServiceCard
                  title={services[4]?.title}
                  image={services[4]?.imgUrl}
                  height="h-[150px] md:h-[300px]"
                />
              </div>
              <div className="w-2/3">
                <ServiceCard
                  title={services[5]?.title}
                  image={services[5]?.imgUrl}
                  height="h-[150px] md:h-[300px]"
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
